import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MappingServiceInterface } from "../admin-page/mapping-service.interface";
import { PayCode } from "../models/pay-code";
import { ConfigService } from "./config.service";

@Injectable({
    providedIn: 'root'
})
export class TimePayCodeMappingService implements MappingServiceInterface {

    readonly apiServer: string;

    constructor(private configService: ConfigService,
        private http: HttpClient) {
        this.apiServer = this.configService.appSettings.webApiServer + "api/PayCode/";
    }   
    async getItemsToMap(offset: number, totalItems: number, searchText: string, orderBy: string, direction: string, unmappedOnly: boolean): Promise<PayCode[]> {
        const params = new HttpParams()
        .set('mostRecent', 'false')
        .set('offset', offset.toString())
        .set('totalItems', totalItems.toString())
        .set('searchText', searchText)
        .set('orderBy', orderBy)
        .set('direction', direction)
        .set('unmappedOnly', unmappedOnly.toString());

    return await this.http.get<PayCode[]>(`${this.apiServer}GetPayCodeInfiniteScroll`, { params: params }).toPromise<PayCode[]>();
    }

    async getUnmappedItemCount(): Promise<number> {
        return await this.http.get<number>(`${this.apiServer}GetAllUnmappedPayCodesCount`).toPromise<number>();
    }

    async saveMapping(mapping: PayCode) {
        return await this.http.post<PayCode>(`${this.apiServer}SavePayCode`, JSON.stringify(mapping)).toPromise<PayCode>();
    }
}